import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BigIntBaseEntity } from './base.entity';
import { EmailRecordEntity } from './email-record.entity';

@Entity('email_attachment', {}, { auditable: false })
export class EmailAttachmentEntity extends BigIntBaseEntity {
	@Column({ name: 'fk_email_record__id', type: 'bigint', unsigned: true })
	@Index()
	public emailRecordId!: string;

	@ManyToOne(() => EmailRecordEntity, (record) => record.attachments)
	@JoinColumn({ name: 'fk_email_record__id' })
	public emailRecord!: EmailRecordEntity;

	@Column({
		name: 'external_id',
		type: 'varchar',
		length: 512,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_as_cs',
	})
	public externalId!: string;

	@Column({ type: 'varchar', length: 255 })
	public name!: string;

	@Column({ name: 'mime_type', type: 'varchar', length: 150 })
	public mimeType!: string;

	@Column({ type: 'int', unsigned: true, nullable: true })
	public size?: number;

	/** Content-ID for inline/embedded images (used in cid: references) */
	@Column({ name: 'content_id', type: 'varchar', length: 255, nullable: true })
	public contentId?: string;

	/** Whether this attachment is inline (embedded in email body) */
	@Column({ name: 'is_inline', type: 'boolean', default: false })
	public isInline!: boolean;
}
